jQuery(document).ready(function ($) {
  $('#side-label-contact .side-label-contact__handle').click(function(e){
    e.preventDefault();
    $this = $(this).parent();
    if($($this).hasClass('is-open')){
      $($this).removeClass('is-open');
    } else {
      $($this).addClass('is-open');
    }
  });
});